// Gerenciador isolado para os vídeos assistidos
const WATCHED_STORAGE_KEY = 'doisplay_watched_videos';

export const getWatchedVideos = (): string[] => {
  try {
    const data = localStorage.getItem(WATCHED_STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    return [];
  }
};

export const isVideoWatched = (videoId: string): boolean => {
  const watched = getWatchedVideos();
  return watched.includes(videoId);
};

export const toggleWatchedStatus = (videoId: string): boolean => {
  try {
    const watched = getWatchedVideos();
    let updated: string[];
    
    if (watched.includes(videoId)) {
      updated = watched.filter(id => id !== videoId); // Remove se já tava assistido
    } else {
      updated = [...watched, videoId]; // Adiciona
    }
    
    localStorage.setItem(WATCHED_STORAGE_KEY, JSON.stringify(updated));
    
    // Dispara um evento personalizado para atualizar a tela na mesma hora se precisar
    window.dispatchEvent(new Event('doisplay_watched_updated'));
    
    return updated.includes(videoId);
  } catch (e) {
    return false;
  }
};
